import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PrivateRoute.scss'; 

const PrivateRoute = ({ children }) => {
  console.log("PrivateRoute.jsxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();
  const [mailVerified, setMailVerified] = useState(null);

  useEffect(() => {
    console.log("Token: ", localStorage.getItem('token'));
    const token = localStorage.getItem('token');
    if (!token) {
      console.log("Token is null or empty");
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_API_URL + '/api/verifyToken/', {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "token": localStorage.getItem('token'),
          })
        });
        if (response.ok) {
        fetch(process.env.REACT_APP_API_URL + '/api/isVerified/', {
            method: "GET",
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('token'),
                'School-ID': sessionStorage.getItem('actual_school'),
            },
        }).then(response => response.json())
            .then(data => {
                setIsAuthenticated(true);
                setMailVerified(data.user_is_verified);
                if(data.user_is_verified){
                    response.json().then(data => {
                        localStorage.setItem('user', true);
                    });
                } else {
                  setMailVerified(false);
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        } else {
          setIsAuthenticated(false);
          return navigate('/');
        }
      } catch (error) {
        console.error('Error verifying token:', error);
        setIsAuthenticated(false);
        return navigate('/');
      }
    };

    verifyToken();
  }, [navigate]);

  if (isAuthenticated === null || mailVerified === null) {
    return (
      null
    );
  }

  if (isAuthenticated && mailVerified) {
    return children;
  } else if (!isAuthenticated ) {
    return navigate('/');
  } else {
    return navigate('/mailenviado');
  }
};

export default PrivateRoute;
